import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { TextButton, Text, Box } from '@wix/design-system';
import s from './EnterpriseBannerFeatureItem.scss';
import classNames from 'classnames';
import { EnterpriseFeaturesItemData } from '../../../pages/PlansPage/Enterprise/EnterpriseFeatures';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { PurchaseMode } from 'enums';

export const EnterpriseBannerFeatureItem: React.FC<
  EnterpriseFeaturesItemData & {
    isReplaceChangePlanPurchaseModeEnabled: boolean;
    isUnifiedChangePlanPhase1Enabled: boolean;
  }
> = ({
  icon,
  title,
  body,
  link,
  isReplaceChangePlanPurchaseModeEnabled,
  isUnifiedChangePlanPhase1Enabled,
}) => {
  const { t } = useTranslation();
  const { purchaseMode, isChangePlan } = usePageModeContext();

  const purchaseModeClassName =
    isReplaceChangePlanPurchaseModeEnabled &&
    isChangePlan &&
    !isUnifiedChangePlanPhase1Enabled
      ? s[PurchaseMode.CHANGE_PLAN]
      : s[purchaseMode];

  return (
    <Box key={title} direction='vertical'>
      <div
        className={classNames(s.featureIcon, s[icon], purchaseModeClassName)}
      ></div>
      <Box marginTop='8px'>
        <Text weight='bold' size='small'>
          {t(title)}
        </Text>
      </Box>
      <Box marginTop='3px'>
        <Text size='small'>
          <Trans i18nKey={body} values={link}>
            feature text
            <TextButton
              as='a'
              size='medium'
              target='_blank'
              href={t(link ?? '')}
            >
              link label
            </TextButton>
          </Trans>
        </Text>
      </Box>
    </Box>
  );
};
